import { Link, type NavigateFunction } from 'react-router';

import { legacyTheme, styled } from '@prose-ui/legacy';

import { Image } from 'Components/Image';

import arrowLeft from 'assets/images/icon_arrow_left.svg';

const Root = styled.div<{ hasMargin: boolean; isDisplayBlock: boolean }>`
  display: block;
  width: 20px;
  margin-bottom: 10px;
  ${legacyTheme.breakpoints.up('xs')} {
    margin: ${(props) => (props?.hasMargin ? '20px 20px 0px' : '0px 0px 10px')};
  }
  ${legacyTheme.breakpoints.up('sm')} {
    display: ${(props) => (props?.isDisplayBlock ? 'block' : 'none')};
  }
`;

const Button = styled.button`
  width: 100%;
  padding: 0;

  border: none;
  background: transparent;

  cursor: pointer;
`;

type GoBackButtonProps = {
  dataTestId?: string;
  displayAllDevices?: boolean;
  history?: NavigateFunction | null;
  hasMargin?: boolean;
  to?: string;
  className?: string;
};

export const GoBackButton = ({
  dataTestId,
  displayAllDevices = false,
  history = null,
  hasMargin = false,
  to = '/account/nav/',
  className,
}: GoBackButtonProps) => {
  return (
    <Root
      className={className}
      data-testid={dataTestId}
      hasMargin={hasMargin}
      isDisplayBlock={displayAllDevices}
    >
      {history ? (
        <Button data-testid="go-back-btn" onClick={() => history(-1)}>
          <Image
            alt="Left arrow - Back to the previous icon - vector"
            height={16}
            src={arrowLeft}
            width={20}
          />
        </Button>
      ) : (
        <Link data-testid="go-back-btn" to={to}>
          <Image
            alt="Left arrow - Back to the previous icon - vector"
            height={16}
            src={arrowLeft}
            width={20}
          />
        </Link>
      )}
    </Root>
  );
};
